/**
 * AR + 360° viewer — shared aspect-mapping helper.
 *
 * Picker emits a size token like "24x36"; the corresponding design's
 * artwork lives in one of three aspect-ratio variants on GCS:
 *   - 4x5  → 8x10, 16x20
 *   - 3x4  → 18x24
 *   - 2x3  → everything else (canvas portrait, large landscapes)
 *
 * This mapping is identical to the one in gallery-builder.js's
 * `chooseAspect()` — replicated here as a tiny standalone helper so
 * both the AR viewer and any other theme script can consume it without
 * pulling in the gallery-builder bundle.
 *
 * Exposed on `window.YukiArAspect` for cross-script access.
 */
(function () {
  function chooseAspect(size) {
    switch (size) {
      case '8x10':
      case '16x20':
        return '4x5';
      case '18x24':
        return '3x4';
      default:
        return '2x3';
    }
  }
  window.YukiArAspect = { chooseAspect: chooseAspect };
})();
